"use strict";

import accordion from "./helper.accordion";
import printPage from "./helper.print";
import windowOpen from "./helper.windowOpen";
import dataFx from "./helper.dataFx";
import scrollToElement from "./helper.scrollToElm";
import tableOverflow from "./helper.tableOverflow";
import tableRowClick from "./helper.tableRowClick";
import isTouchDevice from "./helper.isTouchDevice";
import isMobileDevice from "./helper.isMobile";
import toggler from "./helper.toggler";
import addOrUpdateQueryString from "./helper.addOrUpdateQueryString";
import getTopLevelCountryCode from "./helper.getTopLevelCountryCode";
import menu from "./helper.menu";
import togglerClass from "./helper.togglerClass";
import loader from "./helper.loader";
import elmSticky from "./helper.sticky";

export default {
    accordion,
    printPage,
    windowOpen,
    dataFx,
    scrollToElement,
    tableOverflow,
    tableRowClick,
    toggler,
    addOrUpdateQueryString,
    isTouchDevice,
    isMobileDevice,
    getTopLevelCountryCode,
    menu,
    togglerClass,
    loader,
    elmSticky,
};
